import { render } from "./ParcoursUnitePage.vue?vue&type=template&id=e2a84208"
import script from "./ParcoursUnitePage.vue?vue&type=script&lang=js"
export * from "./ParcoursUnitePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__